import script from "./CollectionsBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectionsBlock.vue?vue&type=script&setup=true&lang=ts"

import "./CollectionsBlock.vue?vue&type=style&index=0&id=65947460&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65947460"]])

export default __exports__